module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-chalk-2-bb471ae97a6e97d57447f02e2d784ffb.webp";